<template>
    <div id="card-info-lead">
        <div class="card border-radius-3">
            <div :class="'card-content center '+setCurrent()">
                <i class="material-icons medium white-text">{{ icone }}</i>
                <p class="white-text lighten-4">{{ titulo }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['current', 'titulo', 'icone'],
        data: () => ({}),
        methods: {
            setCurrent() {
                if (this.current) {
                    return 'gradient-45deg-light-blue-cyan';
                } else {
                    return 'gradient-45deg-blue-grey-blue-grey';
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/CardInfo.vue